import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
`;

const Placeholder = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
`;

export default function NotesModule() {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load notes from localStorage
    try {
      const savedNotes = localStorage.getItem('dizee_notes');
      if (savedNotes) {
        setNotes(JSON.parse(savedNotes));
      }
    } catch (error) {
      console.error('Failed to load notes:', error);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <Placeholder>Loading notes...</Placeholder>;
  }

  // Match mock: keep this module mostly empty for now
  return <Container />;
}

